<template>
  <div id="rateassist-accessorials">
    <div class="row">
      <div class="col-xs-12">
        <div class="shadow clearfix">
          <hr class="hr-text" data-content="ACCESSORIAL"/>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="form-group">
              <label for="acc-fc" class="form-label">Financial Code</label>
              <select v-model="entity.financialCode" class="form-control" id="acc-fc">
                <option value=""></option>
                <option v-for="option in financialCodes" :value="option.id">{{ option.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="form-group">
              <label for="acc-desc" class="form-label">Static Cost</label>
              <input type="text" v-model="entity.description" class="form-control" id="acc-desc"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="form-group">
              <label for="acc-rate" class="form-label">Amount</label>
              <input type="number" step="0.01" v-model="entity.rate" class="form-control" id="acc-rate"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 col-md-4">
            <div class="form-group">
              <label for="acc-currency" class="form-label">Currency</label>
              <select v-model="entity.rateCurrency" class="form-control" id="acc-currency">
                <option value=""></option>
                <option v-for="option in currencies" :value="option.id">{{ option.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-4">
            <div class="form-group">
              <label for="acc-rp" class="form-label">Per</label>
              <select v-model="entity.ratePer" class="form-control" id="acc-rp">
                <option value=""></option>
                <option v-for="option in ratesPer" :value="option.id">{{ option.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-5 col-md-2">
            <div class="form-group">
              <label for="acc-min" class="form-label">Minimum Charge</label>
              <input type="number" step="0.01" v-model="entity.minimumCost" class="form-control" id="acc-min"/>
            </div>
          </div>
          <div class="col-xs-12 col-sm-2 col-md-2">
            <div class="form-group">
              <label for="advice" class="form-label">Advice only?</label>
              <div class="material-switch">
                <input id="advice" type="checkbox" v-model="entity.adviceOnly"/>
                <label for="advice" class="label-success"></label>
              </div>
            </div>
          </div>
          <div class="col-xs-12">
            <hr>
            <div class="pull-right">
              <div class="btn btn-success" @click="save">
                {{ saveOrUpdate }}
              </div>
              <div class="btn btn-danger" @click="doClear">
                Clear
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12">
        <vue-table
          :tableData="accessorials"
          tableTitle="Accessorials"
          v-on:table-edit-request="updateActive"
          :showEdit="true"
          v-on:table-delete-request="doDelete"
          :showDelete="true"
          :fields="fields"
        ></vue-table>
      </div>
    </div>
  </div>
</template>
<script>
  import LookupHelperMixin from '../../mixins/Helpers'
  import VueTable from '../../../helpers/VueTable.vue'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  import TransformMixin from '../../mixins/TransformMixin'
  export default {
    name: 'TariffAdditions',
    props: ['accs', 'lookup'],
    mixins: [ LookupHelperMixin, TransformMixin ],
    components: {
      VueTable
    },
    data () {
      return {
        fields: [
          { header: 'Description', prop: 'description' },
          { header: 'Financial Code', prop: item => item.financialCode ? this.getFinancialCode(item.financialCode) : '' },
          { header: 'Amount', prop: 'rate', numericalField: true },
          { header: 'Advice Only?', prop: item => item.adviceOnly ? 'Y' : 'N' }
        ],
        updateClicked: false,
        transformForUpdate: {
          financialCode: this.toMinus,
          rate: this.toZero,
          rateCurrency: this.toMinus,
          ratePer: this.toMinus,
          minimumCost: this.toZero
        },
        accessorials: [],
        canEmit: true,
        entity: {
          id: null,
          financialCode: null,
          description: null,
          rate: null,
          rateCurrency: null,
          ratePer: null,
          minimumCost: null,
          adviceOnly: null,
          lookup: null
        }
      }
    },
    computed: {
      financialCodes () {
        return this.$store.getters['systemOption/financialCodes'].sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      },
      ratesPer () {
        return this.sortedOptions('BREAKPOINT_UNIT')
      },
      saveOrUpdate () {
        return this.entity.id !== null ? 'Update' : 'Save'
      },
      saveUrl () {
        return this.entity.id ? API.UPDATE_ADMIN_ENTITY('lookup-addition', this.entity.id) : API.CREATE_ADMIN_ENTITY('lookup-addition')
      },
      saveMethod () {
        return this.entity.id ? 'put' : 'post'
      },
      isUpdate () {
        return this.entity.id !== null
      },
      requestBody () {
        return this.isUpdate ? this.transformedEntity : this.nullifyEntity
      }
    },
    watch: {
      accessorials: {
        deep: true,
        handler: function (newVal, oldVal) {
          if (this.canEmit) {
            this.$emit('updating', newVal)
          }
        }
      },
      accs: {
        deep: true,
        handler: function (newVal, oldVal) {
          this.canEmit = false
          if (JSON.stringify(newVal) !== JSON.stringify(this.accessorials)) {
            this.accessorials = newVal
          }
        }
      }
    },
    methods: {
      getFinancialCode (find) {
        let fc = this.financialCodes.find(({id}) => find == id)
        return fc ? fc.name : ''
      },
      doDelete ({ item, index }) {
        this.$http.delete(API.DELETE_ADMIN_ENTITY('lookup-addition', item.id))
        .then(res => {
          let i = this.accessorials.findIndex(({id}) => item.id === id)
          if (i > -1) {
            this.accessorials.splice(i, 1)
          }
          event.$emit('toast', { type: 'success', message: 'Accessorial deleted' })
          this.doClear()
        }).catch(err => {
          event.$emit('toast', { type: 'error', message: err.message })
          console.log(err)
        })
      },
      save () {
        if (!this.updateClicked) {
          this.updateClicked = true
          this.entity.lookup = this.lookup
          let msg = this.isUpdate ? 'Accessorial Updated' : 'Accessorial Added to Tariff'
          this.$http[this.saveMethod](this.saveUrl, this.requestBody)
          .then(({data}) => {
            if (data.hasOwnProperty('id')) {
              this.updateClicked = false
              this.entity.id = data.id
              this.addToList({ ...this.entity })
              event.$emit('toast', { type: 'success', message: msg })
            }
          }).catch(err => {
            this.updateClicked = false
            event.$emit('toast', { type: 'error', message: err.message })
            console.log(err)
          })
        }
      },
      addToList (acc) {
        let i = this.accessorials.findIndex(access => access.id === acc.id)
        if (i === -1) {
          this.accessorials.push(acc)
        } else {
          for (let prop in acc) {
            this.accessorials[i][prop] = acc[prop]
          }
        }
        this.doClear()
      },
      doClear () {
        this.$nextTick(() => {
          let item = {
            id: null,
            financialCode: null,
            description: null,
            rate: null,
            rateCurrency: null,
            ratePer: null,
            minimumCost: null,
            adviceOnly: null,
            lookup: this.lookup
          }
          this.updateActive({ item, index: null })
        })
      },
      updateActive ({ item, index }) {
        for (let prop in item) {
          this.entity[prop] = item[prop]
        }
      },
      addRow () {
        this.accessorials.push({
          financialCode: null,
          description: null,
          rate: 0,
          rateCurrency: null,
          ratePer: null,
          minimumCost: 0,
          adviceOnly: false
        })
        this.$emit('updating', this.accessorials)
      },
      remove (i, acc) {
        this.accessorials.splice(i, 1)
        this.$emit('updating', this.accessorials)
      },
      sortedOptions (type) {
        return this.getSystemOptions(type).sort((a, b) => {
          return a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// TariffAdditions.vue?41ce5360